<template>
  <div>
    <app-spinner v-if="!is_loaded"/>
    <template v-else>
      <app-cells><h1 class="title">Employees dashboard</h1></app-cells>
      <template v-if="no_contract_options.length">
        <app-cells>
          <h2 class="title">No active agreement of employment</h2>
        </app-cells>
        <v-client-table
          :data="no_contract_options"
          :columns="table_no_contract.columns"
          :options="table_no_contract.options"
          class="table-default"
          :class="{ 'table-default--loading': no_contract_preloader }"
        >
          <template #h__first_name><div class="table-default__left">Name</div></template>
          <template #h__department><div class="table-default__left">Department</div></template>
          <template #h__position><div class="table-default__left">Position</div></template>
          <template #h__employment_status><div class="table-default__left">Status</div></template>
          <template #first_name="{ row }">
            <div class="table-default__left table-default__left--photo">
              <div class="table-default__photo">
                <img :src="getUserAvatar(row.crop.crop_url, row.gender?.code || null)" alt="Avatar">
              </div>
              <router-link :to="{ name: 'employees-contracts-salaries', params: { id: row.id } }" class="table-default__link-border">
                {{ row.first_name }} {{ row.last_name }}
              </router-link>
            </div>
          </template>
          <template #department="{ row }"><div class="table-default__left">{{ row.department.name }}</div></template>
          <template #position="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
          <template #employment_status="{ row }">
            <div class="table-default__left">
              <template v-if="row.employment_status">
                <div v-if="row.contract_expire && row.employment_status.code === 'working'">
                  {{ row.employment_status.name }} {{ row.employment_type ? `(${row.employment_type.name})` : '' }} {{ row.employment_status.code === 'working' ? row.seniority : '' }}
                </div>
                <div v-if="row.contract_expire && row.employment_status.code !== 'working'">
                  {{ row.employment_status.name }} {{ row.employment_type ? `(${row.employment_type.name})` : '' }}
                </div>
                <div v-if="!row.contract_expire">
                  {{ row.employment_status.name }} {{ row.employment_type ? `(${row.employment_type.name})` : '' }} {{ row.employment_status.code === 'working' ? row.seniority : '' }}
                </div>
              </template>
              <template v-else>-</template>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :click-handler="onClickPaginationNoContract"
              v-if="pagination_no_contract.pages > 1"
              v-model="pagination_no_contract.page"
              :page-count="pagination_no_contract.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_no_contract.count"
            :count="no_contract_options.length"
            :page="pagination_no_contract.page"
            :limit="5"
          />
        </app-cells>
      </template>
      <template v-if="no_salary_options.length">
        <app-cells>
          <h2 class="title">No info about current salary</h2>
        </app-cells>
        <v-client-table
          :data="no_salary_options"
          :columns="table_no_salary.columns"
          :options="table_no_salary.options"
          class="table-default"
          :class="{ 'table-default--loading': no_salary_preloader }"
        >
          <template #h__first_name><div class="table-default__left">Name</div></template>
          <template #h__department><div class="table-default__left">Department</div></template>
          <template #h__position><div class="table-default__left">Position</div></template>
          <template #h__employment_status><div class="table-default__left">Status</div></template>
          <template #first_name="{ row }">
            <div class="table-default__left table-default__left--photo">
              <div class="table-default__photo">
                <img :src="getUserAvatar(row.crop.crop_url, row.gender?.code || null)" alt="Avatar">
              </div>
              <router-link :to="{ name: 'employees-contracts-salaries', params: { id: row.id } }" class="table-default__link-border">
                {{ row.first_name }} {{ row.last_name }}
              </router-link>
            </div>
          </template>
          <template #department="{ row }"><div class="table-default__left">{{ row.department.name }}</div></template>
          <template #position="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
          <template #employment_status="{ row }">
            <div class="table-default__left">
              <template v-if="row.employment_status">
                <div v-if="row.contract_expire && row.employment_status.code === 'working'">
                  {{ row.employment_status.name }} {{ row.employment_type ? `(${row.employment_type.name})` : '' }} {{ row.employment_status.code === 'working' ? row.seniority : '' }}
                </div>
                <div v-if="row.contract_expire && row.employment_status.code !== 'working'">
                  {{ row.employment_status.name }} {{ row.employment_type ? `(${row.employment_type.name})` : '' }}
                </div>
                <div v-if="!row.contract_expire">
                  {{ row.employment_status.name }} {{ row.employment_type ? `(${row.employment_type.name})` : '' }} {{ row.employment_status.code === 'working' ? row.seniority : '' }}
                </div>
              </template>
              <template v-else>-</template>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :click-handler="onClickPaginationNoSalary"
              v-if="pagination_no_salary.pages > 1"
              v-model="pagination_no_salary.page"
              :page-count="pagination_no_salary.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_no_salary.count"
            :count="no_salary_options.length"
            :page="pagination_no_salary.page"
            :limit="5"
          />
        </app-cells>
      </template>
      <template v-if="no_main_documents_options.length">
        <app-cells>
          <h2 class="title">Missing mandatory documents</h2>
        </app-cells>
        <v-client-table
          :data="no_main_documents_options"
          :columns="table_no_main_documents.columns"
          :options="table_no_main_documents.options"
          class="table-default"
          :class="{ 'table-default--loading': no_main_documents_preloader }"
        >
          <template #h__first_name><div class="table-default__left">Name</div></template>
          <template #h__department><div class="table-default__left">Department</div></template>
          <template #h__position><div class="table-default__left">Position</div></template>
          <template #h__employment_status><div class="table-default__left">Status</div></template>
          <template #first_name="{ row }">
            <div class="table-default__left table-default__left--photo">
              <div class="table-default__photo">
                <img :src="getUserAvatar(row.crop.crop_url, row.gender?.code || null)" alt="Avatar">
              </div>
              <router-link :to="{ name: 'employees-documents', params: { id: row.id } }" class="table-default__link-border">
                {{ row.first_name }} {{ row.last_name }}
              </router-link>
            </div>
          </template>
          <template #department="{ row }"><div class="table-default__left">{{ row.department.name }}</div></template>
          <template #position="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
          <template #national_id="{ row }">
            <div class="table-default__controls">
              <app-document-icon
                name="national_id"
                :fields="{ id: row.national_id, expire: row.national_id_expire, scan_copy: row.national_id_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
              />
              <app-document-icon name="voting_card" :fields="{ id: row.voting_card }" />
              <app-document-icon
                name="tin"
                :fields="{ id: row.tin, scan_copy: row.tin_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
              />
              <app-document-icon
                name="nssf_id"
                :fields="{ id: row.nssf_id, scan_copy: row.nssf_id_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
              />
              <app-document-icon
                name="nhif_id"
                :fields="{ id: row.nhif_id, scan_copy: row.nhif_id_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
              />
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :click-handler="onClickPaginationNoMainDocuments"
              v-if="pagination_no_main_documents.pages > 1"
              v-model="pagination_no_main_documents.page"
              :page-count="pagination_no_main_documents.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_no_main_documents.count"
            :count="no_main_documents_options.length"
            :page="pagination_no_main_documents.page"
            :limit="5"
          />
        </app-cells>
      </template>
      <template v-if="no_driver_documents_options.length">
        <app-cells>
          <h2 class="title">Missing driver’s documents</h2>
        </app-cells>
        <v-client-table
          :data="no_driver_documents_options"
          :columns="table_no_driver_documents.columns"
          :options="table_no_driver_documents.options"
          class="table-default"
          :class="{ 'table-default--loading': no_driver_documents_preloader }"
        >
          <template #h__first_name><div class="table-default__left">Name</div></template>
          <template #h__position><div class="table-default__left">Position</div></template>
          <template #first_name="{ row }">
            <div class="table-default__left table-default__left--photo">
              <div class="table-default__photo">
                <img :src="getUserAvatar(row.crop.crop_url, row.gender?.code || null)" alt="Avatar">
              </div>
              <router-link :to="{ name: 'employees-profile', params: { id: row.id } }" class="table-default__link-border">
                {{ row.first_name }} {{ row.last_name }}
              </router-link>
            </div>
          </template>
          <template #position="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
          <template #national_id="{ row }">
            <div class="table-default__controls">
              <app-document-icon
                name="driver_licence"
                :fields="{ id: row.driver_licence, expire: row.driver_licence_expire, scan_copy: row.driver_licence_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
              />
              <app-document-icon
                name="dpv"
                :fields="{ id: row.driver_police_verification, scan_copy: row.driver_police_verification_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
              />
              <app-document-icon
                name="dsc"
                :fields="{ id: row.driving_school_certificate, scan_copy: row.driving_school_certificate_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
              />
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :click-handler="onClickPaginationNoDriverDocuments"
              v-if="pagination_no_driver_documents.pages > 1"
              v-model="pagination_no_driver_documents.page"
              :page-count="pagination_no_driver_documents.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_no_driver_documents.count"
            :count="no_driver_documents_options.length"
            :page="pagination_no_driver_documents.page"
            :limit="5"
          />
        </app-cells>
      </template>
      <template v-if="personal_details_options.length">
        <app-cells>
          <h2 class="title">Incomplete personal details</h2>
        </app-cells>
        <v-client-table
          :data="personal_details_options"
          :columns="table_personal_details.columns"
          :options="table_personal_details.options"
          class="table-default"
          :class="{ 'table-default--loading': personal_details_preloader }"
        >
          <template #h__first_name><div class="table-default__left">Name</div></template>
          <template #h__department><div class="table-default__left">Department</div></template>
          <template #h__position><div class="table-default__left">Position</div></template>
          <template #first_name="{ row }">
            <div class="table-default__left table-default__left--photo">
              <div class="table-default__photo">
                <img :src="getUserAvatar(row.crop.crop_url, row.gender?.code || null)" alt="Avatar">
              </div>
              <router-link :to="{ name: 'employees-profile', params: { id: row.id } }" class="table-default__link-border">
                {{ row.first_name }} {{ row.last_name }}
              </router-link>
            </div>
          </template>
          <template #communication="{ row }">
            <div class="table-default__controls">
              <button
                v-tooltip="{content: row.email, placement: 'top-start', offset: 10}"
                @click="onCopyContactLink(row.email)"
                class="table-default__activity table-default__activity--mail"
                :class="{'table-default__activity--active': row.email}"
              >
              </button>
              <button
                v-tooltip="{content: row.phone, placement: 'top-start', offset: 10}"
                @click="onCopyContactLink(row.phone)"
                class="table-default__activity table-default__activity--phone"
                :class="{'table-default__activity--active': row.phone}"
              >
              </button>
              <a
                :href="`https://t.me/${row.phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--tg"
                :class="{'table-default__activity--active': row.phone_telegram}"
              >
              </a>
              <a
                :href="`https://wa.me/${row.phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--wa"
                :class="{'table-default__activity--active': row.phone_whatsapp}"
              >
              </a>
            </div>
          </template>
          <template #department="{ row }"><div class="table-default__left">{{ row.department.name }}</div></template>
          <template #position="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
          <template #dob="{ row }">{{ dateFormat(row.dob) }}</template>
          <template #gender="{ row }">{{ row.gender?.name || '-' }}</template>
          <template #region="{ row }">{{ row.region?.name || '-' }}</template>
          <template #village="{ row }">{{ row.village?.name || '-' }}</template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :click-handler="onClickPaginationPersonalDetails"
              v-if="pagination_personal_details.pages > 1"
              v-model="pagination_personal_details.page"
              :page-count="pagination_personal_details.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_personal_details.count"
            :count="personal_details_options.length"
            :page="pagination_personal_details.page"
            :limit="5"
          />
        </app-cells>
      </template>
      <template v-if="family_options.length">
        <app-cells>
          <h2 class="title">No info about family</h2>
        </app-cells>
        <v-client-table
          :data="family_options"
          :columns="table_family.columns"
          :options="table_family.options"
          class="table-default"
          :class="{ 'table-default--loading': family_preloader }"
        >
          <template #h__first_name><div class="table-default__left">Name</div></template>
          <template #h__department><div class="table-default__left">Department</div></template>
          <template #h__position><div class="table-default__left">Position</div></template>
          <template #first_name="{ row }">
            <div class="table-default__left table-default__left--photo">
              <div class="table-default__photo">
                <img :src="getUserAvatar(row.crop.crop_url, row.gender?.code || null)" alt="Avatar">
              </div>
              <router-link :to="{ name: 'employees-profile', params: { id: row.id } }" class="table-default__link-border">
                {{ row.first_name }} {{ row.last_name }}
              </router-link>
            </div>
          </template>
          <template #department="{ row }"><div class="table-default__left">{{ row.department.name }}</div></template>
          <template #position="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
          <template #family="{ row }">
            <div class="family-list">
              <div class="family-list__item">
                <img src="@/assets/img/adult-icon.svg" alt="">
                <span>{{ row.family.adult }}</span>
              </div>
              <div class="family-list__item">
                <img src="@/assets/img/teenager-icon.svg" alt="">
                <span>{{ row.family.teenager }}</span>
              </div>
              <div class="family-list__item">
                <img src="@/assets/img/child-icon.svg" alt="">
                <span>{{ row.family.child }}</span>
              </div>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :click-handler="onClickPaginationFamily"
              v-if="pagination_family.pages > 1"
              v-model="pagination_family.page"
              :page-count="pagination_family.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_family.count"
            :count="family_options.length"
            :page="pagination_family.page"
            :limit="5"
          />
        </app-cells>
      </template>
      <template v-if="emergency_contacts_options.length">
        <app-cells>
          <h2 class="title">Emergency contact less then 2</h2>
        </app-cells>
        <v-client-table
          :data="emergency_contacts_options"
          :columns="table_emergency_contacts.columns"
          :options="table_emergency_contacts.options"
          class="table-default"
          :class="{ 'table-default--loading': emergency_contacts_preloader }"
        >
          <template #h__first_name><div class="table-default__left">Name</div></template>
          <template #h__department><div class="table-default__left">Department</div></template>
          <template #h__position><div class="table-default__left">Position</div></template>
          <template #first_name="{ row }">
            <div class="table-default__left table-default__left--photo">
              <div class="table-default__photo">
                <img :src="getUserAvatar(row.crop.crop_url, row.gender?.code || null)" alt="Avatar">
              </div>
              <router-link :to="{ name: 'employees-profile', params: { id: row.id } }" class="table-default__link-border">
                {{ row.first_name }} {{ row.last_name }}
              </router-link>
            </div>
          </template>
          <template #department="{ row }"><div class="table-default__left">{{ row.department.name }}</div></template>
          <template #position="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :click-handler="onClickPaginationEmergencyContacts"
              v-if="pagination_emergency_contacts.pages > 1"
              v-model="pagination_emergency_contacts.page"
              :page-count="pagination_emergency_contacts.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_emergency_contacts.count"
            :count="emergency_contacts_options.length"
            :page="pagination_emergency_contacts.page"
            :limit="5"
          />
        </app-cells>
      </template>
    </template>
  </div>
</template>

<script>

import { getEmployeesList } from '@/http'
import AppDocumentIcon from '@/components/AppDocumentIcon.vue'
import { format, parse } from 'date-fns'

export default {
  name: 'EmployeesDashboard',
  components: { AppDocumentIcon },
  data() {
    return {
      is_loaded: false,
      no_contract_options: [],
      no_salary_options: [],
      no_main_documents_options: [],
      no_driver_documents_options: [],
      personal_details_options: [],
      family_options: [],
      emergency_contacts_options: [],
      no_contract_preloader: true,
      no_salary_preloader: true,
      contract_expire_preloader: true,
      no_main_documents_preloader: true,
      no_driver_documents_preloader: true,
      personal_details_preloader: true,
      family_preloader: true,
      emergency_contacts_preloader: true,
      table_no_contract: {
        columns: [
          'first_name',
          'department',
          'position',
          'employment_status',
        ],
        options: {
          headings: {
            'first_name': 'Name',
            'department': 'Department',
            'position': 'Position',
            'employment_status': 'Status',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_no_salary: {
        columns: [
          'first_name',
          'department',
          'position',
          'employment_status',
        ],
        options: {
          headings: {
            'first_name': 'Name',
            'department': 'Department',
            'position': 'Position',
            'employment_status': 'Status',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_contract_expire: {
        columns: [
          'first_name',
          'department',
          'position',
          'contract_expire',
          'warnings',
          'issued_equipment_items',
          'employment_status'
        ],
        options: {
          headings: {
            'first_name': 'Name',
            'department': 'Department',
            'position': 'Position',
            'contract_expire': 'Contract expire',
            'warnings': 'Warnings',
            'issued_equipment_items': 'Items',
            'employment_status': 'Status'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_no_main_documents: {
        columns: [
          'first_name',
          'national_id',
          'department',
          'position',
        ],
        options: {
          headings: {
            'first_name': 'Name',
            'national_id': 'Documents',
            'department': 'Department',
            'position': 'Position',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_no_driver_documents: {
        columns: [
          'first_name',
          'national_id',
          'position',
        ],
        options: {
          headings: {
            'first_name': 'Name',
            'national_id': 'Documents',
            'position': 'Position',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_personal_details: {
        columns: [
          'first_name',
          'communication',
          'dob',
          'gender',
          'region',
          'village',
          'department',
          'position',
        ],
        options: {
          headings: {
            'first_name': 'Name',
            'communication': 'Communication',
            'dob': 'Date of birth',
            'gender': 'Gender',
            'region': 'Region',
            'village': 'Village',
            'department': 'Department',
            'position': 'Position',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_family: {
        columns: [
          'first_name',
          'family',
          'department',
          'position',
        ],
        options: {
          headings: {
            'first_name': 'Name',
            'family': 'Family',
            'department': 'Department',
            'position': 'Position',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_emergency_contacts: {
        columns: [
          'first_name',
          'department',
          'position',
        ],
        options: {
          headings: {
            'first_name': 'Name',
            'department': 'Department',
            'position': 'Position',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      pagination_no_contract: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_no_salary: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_contract_expire: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_no_main_documents: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_no_driver_documents: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_personal_details: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_family: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_emergency_contacts: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    Promise.all([
      getEmployeesList({
        page: this.pagination_no_contract.page,
        page_size: 5,
        problem: 'no_contract'
      }),
      getEmployeesList({
        page: this.pagination_no_salary.page,
        page_size: 5,
        problem: 'no_salary'
      }),
      getEmployeesList({
        page: this.pagination_no_main_documents.page,
        page_size: 5,
        problem: 'no_main_documents'
      }),
      getEmployeesList({
        page: this.pagination_no_driver_documents.page,
        page_size: 5,
        problem: 'no_driver_documents'
      }),
      getEmployeesList({
        page: this.pagination_personal_details.page,
        page_size: 5,
        problem: 'personal_details'
      }),
      getEmployeesList({
        page: this.pagination_family.page,
        page_size: 5,
        problem: 'family'
      }),
      getEmployeesList({
        page: this.pagination_emergency_contacts.page,
        page_size: 5,
        problem: 'emergency_contacts'
      })
    ])
      .then(res => {
        this.no_contract_options = res[0].data.results
        this.pagination_no_contract.pages = res[0].data.pages
        this.pagination_no_contract.count = res[0].data.count
        this.no_salary_options = res[1].data.results
        this.pagination_no_salary.pages = res[1].data.pages
        this.pagination_no_salary.count = res[1].data.count
        this.no_main_documents_options = res[2].data.results
        this.pagination_no_main_documents.pages = res[2].data.pages
        this.pagination_no_main_documents.count = res[2].data.count
        this.no_driver_documents_options = res[3].data.results
        this.pagination_no_driver_documents.pages = res[3].data.pages
        this.pagination_no_driver_documents.count = res[3].data.count
        this.personal_details_options = res[4].data.results
        this.pagination_personal_details.pages = res[4].data.pages
        this.pagination_personal_details.count = res[4].data.count
        this.family_options = res[5].data.results
        this.pagination_family.pages = res[5].data.pages
        this.pagination_family.count = res[5].data.count
        this.emergency_contacts_options = res[6].data.results
        this.pagination_emergency_contacts.pages = res[6].data.pages
        this.pagination_emergency_contacts.count = res[6].data.count

        this.no_contract_preloader = false
        this.no_salary_preloader = false
        this.contract_expire_preloader = false
        this.no_main_documents_preloader = false
        this.no_driver_documents_preloader = false
        this.personal_details_preloader = false
        this.family_preloader = false
        this.emergency_contacts_preloader = false

        this.is_loaded = true
      })
  },
  methods: {
    onClickPaginationNoContract(page) {
      this.no_contract_preloader = true
      this.pagination_no_contract.page = page
      getEmployeesList({
        page: this.pagination_no_contract.page,
        page_size: 5,
        problem: 'no_contract'
      })
        .then(res => {
          this.no_contract_options = res.data.results
          this.pagination_no_contract.pages = res.data.pages
          this.pagination_no_contract.count = res.data.count
          this.no_contract_preloader = false
        })
    },
    onClickPaginationNoSalary(page) {
      this.no_salary_preloader = true
      this.pagination_no_salary.page = page
      getEmployeesList({
        page: this.pagination_no_salary.page,
        page_size: 5,
        problem: 'no_salary'
      })
        .then(res => {
          this.no_salary_options = res.data.results
          this.pagination_no_salary.pages = res.data.pages
          this.pagination_no_salary.count = res.data.count
          this.no_salary_preloader = false
        })
    },
    onClickPaginationNoMainDocuments(page) {
      this.no_main_documents_preloader = true
      this.pagination_no_main_documents.page = page
      getEmployeesList({
        page: this.pagination_no_main_documents.page,
        page_size: 5,
        problem: 'no_main_documents'
      })
        .then(res => {
          this.no_main_documents_options = res.data.results
          this.pagination_no_main_documents.pages = res.data.pages
          this.pagination_no_main_documents.count = res.data.count
          this.no_main_documents_preloader = false
        })
    },
    onClickPaginationNoDriverDocuments(page) {
      this.no_driver_documents_preloader = true
      this.pagination_no_driver_documents.page = page
      getEmployeesList({
        page: this.pagination_no_driver_documents.page,
        page_size: 5,
        problem: 'no_driver_documents'
      })
        .then(res => {
          this.no_driver_documents_options = res.data.results
          this.pagination_no_driver_documents.pages = res.data.pages
          this.pagination_no_driver_documents.count = res.data.count
          this.no_driver_documents_preloader = false
        })
    },
    onClickPaginationPersonalDetails(page) {
      this.personal_details_preloader = true
      this.pagination_personal_details.page = page
      getEmployeesList({
        page: this.pagination_personal_details.page,
        page_size: 5,
        problem: 'personal_details'
      })
        .then(res => {
          this.personal_details_options = res.data.results
          this.pagination_personal_details.pages = res.data.pages
          this.pagination_personal_details.count = res.data.count
          this.personal_details_preloader = false
        })
    },
    onClickPaginationFamily(page) {
      this.family_preloader = true
      this.pagination_family.page = page
      getEmployeesList({
        page: this.pagination_family.page,
        page_size: 5,
        problem: 'family'
      })
        .then(res => {
          this.family_options = res.data.results
          this.pagination_family.pages = res.data.pages
          this.pagination_family.count = res.data.count
          this.family_preloader = false
        })
    },
    onClickPaginationEmergencyContacts(page) {
      this.emergency_contacts_preloader = true
      this.pagination_emergency_contacts.page = page
      getEmployeesList({
        page: this.pagination_emergency_contacts.page,
        page_size: 5,
        problem: 'emergency_contacts'
      })
        .then(res => {
          this.emergency_contacts_options = res.data.results
          this.pagination_emergency_contacts.pages = res.data.pages
          this.pagination_emergency_contacts.count = res.data.count
          this.emergency_contacts_preloader = false
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    getUserAvatar(crop_url, gender) {
      if (crop_url) return crop_url
      else {
        if (!gender) {
          return require('@/assets/img/temp/avatar-slug.jpg')
        } else if (gender === 'male') {
          return require('@/assets/img/temp/avatar-slug-male.jpg')
        } else if (gender === 'female') {
          return require('@/assets/img/temp/avatar-slug-female.jpg')
        }
      }
    },
    onCopyContactLink(link) {
      navigator.clipboard.writeText(link)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
  }
}
</script>
<style lang="sass" scoped>
.family-list
  display: flex
  align-items: flex-end
  justify-content: center
  gap: 14px

.family-list__item
  img
    margin-right: 5px

  span
    width: 10px
</style>
